import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  type: "role" | "news";
  id: string;
  size?: "sm" | "md";
  withLabel?: boolean;
}

export default function FavoriteButton({
  type,
  id,
  size = "md",
  withLabel = false
}: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(type, id);

  const sizeClass = size === "sm" ? "h-8 w-8 text-base" : "h-9 w-9 text-lg";

  if (withLabel) {
    return (
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleFavorite(type, id);
        }}
        className={`inline-flex items-center gap-2 rounded-md border px-4 py-2.5 text-sm font-medium transition-colors cursor-pointer ${
          active
            ? "border-primary-300 bg-primary-100 text-primary-700"
            : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        <i className={active ? "ri-heart-3-fill" : "ri-heart-3-line"}></i>
        {active ? "已收藏" : "收藏"}
      </button>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(type, id);
      }}
      aria-label={active ? "取消收藏" : "收藏"}
      className={`flex ${sizeClass} items-center justify-center rounded-full border backdrop-blur transition-colors cursor-pointer ${
        active
          ? "border-primary-300 bg-primary-100/90 text-primary-600"
          : "border-background-200 bg-background-50/90 text-foreground-500 hover:text-primary-600"
      }`}
    >
      <i className={active ? "ri-heart-3-fill" : "ri-heart-3-line"}></i>
    </button>
  );
}